export const deClientPortalAuthenticatedAppPages = {
    authenticatedApp: {
        subtitle: 'Value Management Platform',
        supportNote: {
            prefix: 'Bei Fragen stehen wir Ihnen unter',
            suffix: 'zur Verfügung.',
        },
        formFields: {
            email: 'E-Mail',
            password: 'Passwort',
            code: 'Code',
            newPassword: 'Neues Passwort',
            confirmNewPassword: 'Neues Passwort wiederholen',
        },
        errors: {
            signIn: 'Fehler bei der Anmeldung. Bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut.',
            forgotPasswordSubmit: 'Fehler bei der Passwortänderung. Bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut.',
            confirmSignIn: 'Fehler bei der Anmeldung. Bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut.',
        },
        signIn: {
            title: 'Willkommen',
            description: 'Effizient managen. Informiert entscheiden.',
            forgotPassword: 'Passwort vergessen?',
        },
        forgotPassword: {
            title: 'Passwort zurücksetzen',
            description: 'Geben Sie Ihre E-Mail ein, um einen Code für das Zurücksetzen Ihres Passworts zu erhalten.',
        },
        confirmResetPassword: {
            title: 'Passwort zurücksetzen',
            description: 'Geben Sie den Code ein, den Sie per E-Mail erhalten haben und legen Sie Ihr neues Passwort fest.',
        },
        forceNewPassword: {
            title: 'Passwort festlegen',
            description: 'Legen Sie ein neues Passwort fest, um Ihre Anmeldung abzuschließen.',
            minLengthError: 'Das Passwort muss mind. 8 Zeichen lang sein',
            mismatchError: 'Die Passwörter müssen übereinstimmen',
        },
        restrictedAppraiser: {
            title: 'Weiter zur Gutachterplattform',
            description: 'Sie befinden sich auf der Kundenplattform. Bitte wechseln Sie zu unserer Gutachterplattform.',
            action: 'Zur Gutachterplattform',
        },
    },
    welcomePage: {
        title: 'Willkommen bei einwert',
        description: 'Bevor Sie starten, vervollständigen Sie bitte Ihr Nutzerprofil, indem Sie auf den nachfolgenden Button klicken.',
        cta: 'Zum Profil',
    },
    errorPage: {
        emptyStateTitle: 'Willkommen bei einwert',
        status: {
            unauthorized: {
                title: '401 Zugriff verweigert',
                message:
                    'Ihr Zugriff wurde verweigert. Bitte versuchen Sie, sich abzumelden und erneut anzumelden oder die Seite zu aktualisieren. Falls das Problem weiterhin besteht, wenden Sie sich bitte an den Support.',
            },
            forbidden: {
                title: '403 Zugriff verweigert',
                message: 'Sie haben keine Zugriffsberechtigung. Wenden Sie sich ggf. an den Support.',
            },
            notFound: {
                title: '404 Seite nicht gefunden',
                message: 'Entschuldigung, hier ist wohl etwas schief gelaufen. Die gewünschte Seite kann nicht gefunden werden.',
            },
            default: {
                title: 'Ups...',
                message: 'Entschuldigung, ein unerwarteter Fehler ist aufgetreten.',
            },
        },
        emptyState: {
            assets: 'Hier ist noch nichts zu sehen. Entweder fehlt Ihnen die Berechtigung oder wir haben Ihr erstes Gutachten noch nicht abgeschlossen.',
            analysis:
                'Hier ist noch nichts zu sehen. Entweder fehlt Ihnen die Berechtigung oder Ihr erstes Gutachten ist noch nicht abgeschlossen – erst dann können Sie hier Ihre Immobilien vergleichen.',
            default:
                'Hier ist noch nichts zu sehen. Entweder fehlt Ihnen die Berechtigung oder Ihr erstes Gutachten ist noch nicht abgeschlossen – erst dann sehen Sie hier Ihre Übersicht.',
        },
        supportText: 'Sollte der Fehler weiterhin bestehen, wenden Sie sich an',
        actions: {
            orders: 'Bewertungsaufträge',
            signOut: 'Abmelden',
            back: 'Zurück',
            overview: 'Übersicht',
        },
    },
}
